// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/export_logs/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementExportLogs } from "./constants";
import type { EngagementExportLogsParams, ExportLogsResult } from "./types";

export const getDataTableExportLogs = reactQueryTableFetcherAdapter(
  engagementExportLogs,
  (
    signal: AbortSignal,
    { appGroupId, query = {}, groupby, limit = 20, start = 0, sortdir, sortby }: EngagementExportLogsParams
  ): Promise<ExportLogsResult> => {
    return fetch(
      `/engagement/export_logs`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  }
);
